'use client';

import { useFieldArray, useFormContext   } from 'react-hook-form';
import type { UseFieldArrayProps } from 'react-hook-form';

type UseFieldArrayListArgs<T extends Record<string, any>> = {
	defaultRow: T[string]
	max?:       number
	name:       UseFieldArrayProps<T>['name']
};

export function useFieldArrayList<T extends Record<string, any>>({
	defaultRow,
	max,
	name,
}: UseFieldArrayListArgs<T>) {
	const { control } = useFormContext<T>();
	const {
		append, fields, remove, replace,
	} = useFieldArray({
		control,
		name,
	});
	const add = () => append(defaultRow);
	const clear = () => replace([]);

	const canAddMore = typeof max !== 'number' || fields.length < max;

	return {
		add,
		canAddMore,
		clear,
		fields,
		remove,
	};
}
